import React from 'react'
import PropTypes from 'prop-types'
// import moment from 'moment'
import R from 'ramda'

import {
  COLORS
} from '_constants'

import {
  notNilOrEmpty
} from '_utils'

const isOdd = n => n % 2

const HiView = ({
  text,
  tReg
}) => {
  const arr = text
    .split(tReg.regex)
    .reduce((acc, v, i) => {
      const line = isOdd(i) ? (<span key={i}>{v}</span>)
        : (<span key={i}>{v}<span style={{color: COLORS.AUTOCOMPLETE.HIGHLIGHT}}>{tReg.term}</span></span>)
      return acc.concat(line)
    }, [])
    .filter(x => x)
  return (
    <React.Fragment>
      { arr }
    </React.Fragment>
  )
}

HiView.propTypes = {
  text: PropTypes.string.isRequired,
  tReg: PropTypes.object.isRequired
}

const SuggestionView = ({
  label,
  text,
  small = false,
  tReg
}) => small
  ? (<div><small><b>{label}</b>: <HiView text={String(text)} tReg={tReg} /></small></div>)
  : (<div><b>{label}</b>: <HiView text={String(text)} tReg={tReg} /></div>)

SuggestionView.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  tReg: PropTypes.object.isRequired,
  small: PropTypes.bool
}

const hasTheText = ({text, tReg}) => notNilOrEmpty(text) &&
  R.test(tReg.regex, text)

const SuggestionItem = R.ifElse(
  hasTheText,
  SuggestionView,
  R.ifElse(
    R.propEq('always', true),
    ({label, text}) => (<div><b>{label}</b>: {text}</div>),
    R.always(null)
  )
)

SuggestionItem.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  always: PropTypes.bool,
  tReg: PropTypes.object.isRequired,
  small: PropTypes.bool
}

export default SuggestionItem



// WEBPACK FOOTER //
// ./webAdmin/views/suggestionItem.js